const CoverScrollDownButton = (domEl) => {
	const scrollButton = domEl.querySelector('.scroll-down-button');
	if(!scrollButton) {
		return;
	}

	scrollButton.addEventListener('click', function() {
		const nextSection = domEl.nextElementSibling;
		const header = document.getElementById('the-header');

		if(nextSection && header) {
			// Get the header height
			const headerHeight = header.offsetHeight;

			// Get the position of the next section relative to the viewport
			const nextSectionRect = nextSection.getBoundingClientRect();

			// Calculate the scroll position, accounting for header height
			const scrollPosition = window.scrollY + nextSectionRect.top - headerHeight;

			// Scroll to the calculated position
			window.scrollTo({
				top: scrollPosition,
				behavior: 'smooth'
			});
		}
		else if(nextSection) {
			// Fallback if header not found
			nextSection.scrollIntoView({ behavior: 'smooth' });
		}
	});
};

export default CoverScrollDownButton;